/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/accessibility'
export default icon
